import React from 'react'
import './x-wallet.scss';
import LogoIcon from './images/x-wallet-dark.svg';
import WalletBannerImg from './images/Wallet-1-640w.svg';
import ChromeStoreBtn from './images/ChromeStore-White.svg';
import WalletFeatures from './images/Chains-59924234-640w.svg';
import FunctionalityImg from './images/Wallet_Swap-640w.svg';
import SecurityImg from './images/ID_Profile-640w.svg';

import FacebookIcon from './images/facebook.svg';
import instagramIcon from './images/instagram.svg';
import LinkedInIcon from './images/LinkedIn.svg';
import RedditIcon from './images/Reddit.svg';
import twitterIcon from './images/twitter.svg';
import YouTubeIcon from './images/YouTube.svg';
import SocialSentIcon from './images/social-sent.svg';
import discordIcon from './images/discord.svg';
import mediumIcon from './images/medium.svg';
import spotifyIcon from './images/spotify.svg';
import BlogIcon from './images/blog.svg';

import XWalletIcon from './images/X-Wallet-Icon.svg';



const LandingPage = () => {
  return (
    <div className='landingpage-x-wallet'>
      
      <div className='wallet-menu'>
        <div className="container">
          <div className='menu-inner'>
            <a href='/' className='logo'><img src={LogoIcon} /></a>
              <ul>
                  <li>
                      <a href='/'>Home</a>
                  </li>
                  <li>
                      <a href='/terms-conditions'>Terms & Conditions</a>
                  </li>
                  <li>
                      <a href='/privacy-policy'>Privacy Policy</a>
                  </li>
                  <li>
                      <a href='https://chromewebstore.google.com/detail/xwallet/pofheakpngfbdfeidiippmmckgpdceoh' className='download-wallet' target='_blank'>
                      
                       <svg class="wallet-icon" viewBox="0 0 24 24">
                <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
            </svg>
            Download Wallet
            <svg class="download-icon" viewBox="0 0 24 24">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
            </svg>
                      </a>
                  </li>
              </ul>
              </div>
        </div>
      </div>
      <div className='banner-section'>
        <div className="container">
          <div className="row">
            <div className="col-md-6 order-2 order-md-1">
              <div className="banner-content">
                <div>
                  <h2>x_Perience the Next-Gen  Crypto Wallet</h2>
                  <p>x_Wallet will redefine your crypto experience. It is more than a place for holding tokens and secure transactions. The x_Wallet's user-friendly design will transform how you view, engage, and transact in crypto. </p>
                  <p>From Ethereum to Solana and everything in between, manage it all with just one wallet. The x_Wallet makes every interaction smart, every step intuitive, and every transaction simple.</p>
                  <p className='size-18'>Download the most indispensable crypto wallet you'll ever need!</p>
                  <a href='https://chromewebstore.google.com/detail/xwallet/pofheakpngfbdfeidiippmmckgpdceoh' className='chrome-web-store-btn' target='_blank'><img src={ChromeStoreBtn} /></a>
                </div>
              </div>
            </div>
            <div className='col-md-6 order-1 order-md-2'>
              <div className='cryptowallet-img'>
                <img src={WalletBannerImg} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='wallet-features-section space-t-b'>
           <div className="container">
             <h2>Wallet Features</h2>
            <div className="row">
               <div className='col-md-6'>
                <div className='cryptowallet-img'>
                  <img src={WalletFeatures} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="left-content-features">
                  <div>
                    <p className='label-p'>Interoperability</p>
                  <h4>No More Need for Multiple Wallets</h4>
                  <p>L1X's interoperability streamlines the crypto experience for enthusiasts by offering the ability to view and manage all their crypto wallets from a single wallet. </p>
                  <p>With L1X, there's no need to juggle different wallet providers over various chains, as you can effortlessly access, view, and handle all your crypto assets from one central wallet. This consolidation enhances wallet security and adds a layer of convenience, rendering other wallet solutions unnecessary.</p>
                  </div>
                </div>
              </div>
             
            </div>
           </div>
      </div>
      <div className='wallet-features-section bg-color-darknavyblue space-t-b'>
           <div className="container">
            <div className="row">
              
              <div className="col-md-6 order-2 order-md-1">
                <div className="left-content-features">
                  <div>
                    <p className='label-p'>Functionality</p>
                  <h4>Swap, Stake, Lend & Borrow Cross-Chain intelligently</h4>
                  <p>Looking for an intelligent way to dive into the world of crypto? Look no further than the L1X wallet! We've taken all the hard stuff and made it easy for you—no need to be a crypto whiz. </p>
                  <p>Swap, stake, lend, borrow – all these big words are made simple with the L1X wallet. Our smart wallet does the heavy lifting so you can enjoy the experience.</p>
                  <p>Want to trade across different blockchain networks? No problem! With our wallet, everything is just a click away. Get started today, and discover the more brilliant, easier way to enjoy everything crypto offers. </p>
                  </div>
                </div>
              </div>
              <div className='col-md-6 order-1 order-md-2'>
                <div className='cryptowallet-img'>
                  <img src={FunctionalityImg} />
                </div>
              </div>
              
            </div>
           </div>
      </div>

      <div className='wallet-features-section space-t'>
           <div className="container">
            <div className="row">
              <div className='col-md-6'>
                <div className='cryptowallet-img'>
                  <img src={SecurityImg} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="left-content-features">
                  <div>
                    <p className='label-p'>Security</p>
                  <h4>Security Without Sacrificing Experience</h4>
                  <p>We're taking security to the next level and revolutionizing the way we protect your data with the introduction of L1X ID. Coming in October of 2023 to the L1X wallet. </p>
                  <p>This innovative feature will redefine what it means to be secure in the crypto world.</p>
                  </div>
                </div>
              </div>
              
            </div>
           </div>
      </div>


    <div className='wallet-features-section bg-color-darknavyblue space-t-b'>
           <div className="container">
            <div className="row">
              
              <div className="col-md-6 order-2 order-md-1">
                <div className="left-content-features">
                  <div>
                    <p className='label-p'>Earning Possibilities</p>
                  <h4>Download, Install, and Start Earning</h4>
                  <p>Any smart device can join the decentralized consensus mechanism.</p>
                  <p>We use hashed zero knowledge proof for fast transaction validation without mining or specialist hardware. Now anyone can download, install, and start earning a portion of the transaction fees as a mobile validator.</p>
                  </div>
                </div>
              </div>
              <div className='col-md-6 order-1 order-md-2'>
                <div className='logo-earning-img'>
                  <div className='text-center'>
                    <p><img className='xwalleticon-x' src={XWalletIcon} /></p>
                  <a href='https://chromewebstore.google.com/detail/xwallet/pofheakpngfbdfeidiippmmckgpdceoh'  target='_blank' className='btn-web-store'><img src={ChromeStoreBtn} /></a>
                  </div>
                </div>
              </div>
              
            </div>
           </div>
      </div>



<div className='wallet-features-section bg-crl-gradiunt space-t'>
           <div className="container">
            <div className="row">
              <div className='col-md-6'>
                <div className='cryptowallet-img'>
                  <img src={WalletBannerImg} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="left-content-features">
                  <div>
                    <h5>Download</h5>
                  <h4>x_Wallet Today!</h4>
                  <p>Truly the last crypto wallet you will ever need!</p>
                  <div className='cryptowallet-img'>
                  <a href='https://chromewebstore.google.com/detail/xwallet/pofheakpngfbdfeidiippmmckgpdceoh' target='_blank' className='btn-web-store'><img src={ChromeStoreBtn} /></a>
                  </div>
                  </div>
                </div>
              </div>
              
            </div>
           </div>
      </div>
      <div className='footer-section-homepage'>
        <div className="container">
          <div className='flex-footer-section'>
          <p>
            © 2025 All Rights Reserved | Layer One X
          </p>
          
          <ul className='social-ul'>
            <li>
              <a href='https://www.facebook.com/LayerOneX/' target='_blank'>
                <img src={FacebookIcon} />
              </a>
            </li>
            
            <li>
              <a href='https://t.me/Layer1X' target='_blank'>
                <img src={SocialSentIcon} />
              </a>
            </li>
             <li>
              <a href='https://discord.com/invite/LayerOneX' target='_blank'>
                <img src={discordIcon} />
              </a>
            </li>
            <li>
              <a href='https://open.spotify.com/show/03qULl4aEnBIR1VYJqxWx7' target='_blank'>
                <img src={spotifyIcon} />
              </a>
            </li>
            
            <li>
              <a href='https://medium.com/@Layeronex' target='_blank'>
                <img src={mediumIcon} />
              </a>
            </li>
            
            <li>
              <a href='https://www.instagram.com/layerone_x/' target='_blank'>
                <img src={instagramIcon} />
              </a>
            </li>
            <li>
              <a href='https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Flayer-one-x%2Fmycompany%2Fverification%2F' target='_blank'>
                <img src={LinkedInIcon} />
              </a>
            </li>
          
            <li>
              <a href='https://x.com/LayerOneX' target='_blank'>
                <img src={twitterIcon} />
              </a>
            </li>
            <li>
              <a href='https://www.youtube.com/@LayerOneX' target='_blank'>
                <img src={YouTubeIcon} />
              </a>
            </li>
            <li>
              <a href='https://www.reddit.com/r/LayerOneX/?rdt=34212' target='_blank'>
                <img src={RedditIcon} />
              </a>
            </li>
            <li>
              <a href='https://blog.l1x.foundation/' target='_blank'>
                <img src={BlogIcon} />
              </a>
            </li>
            
          </ul>
        </div>
        </div>
      </div>


    </div>
  )
}

export default LandingPage
